import React from 'react';
import styles from './StepRow.module.css';

// One "how to" step: a numbered oval + copy, paired with its illustration.
// `reverse` puts the illustration on the left at desktop widths (step 2).
const StepRow = ({id, number, title, lead, body, illustration, reverse}) => (
    <div id={id} className={styles.row}>
        <div className={`${styles.text} ${reverse ? styles.textReversed : ''}`}>
            <div className={styles.number}>{number}</div>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.lead}>{lead}</p>
            <p className={styles.body}>{body}</p>
        </div>
        <div className={`${styles.illustration} ${reverse ? styles.illustrationReversed : ''}`}>
            {illustration}
        </div>
    </div>
);

export default StepRow;
